import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className="py-12 px-4 bg-gray-900 text-white">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-8">
          <h3 className="text-2xl font-bold mb-4">AI 트렌드 뉴스레터</h3>
          <p className="text-gray-400 max-w-2xl mx-auto">
            글로벌 AI 커뮤니티의 최신 인사이트를 매주 5분 요약으로 전달하는 뉴스레터입니다.
          </p>
        </div>
        
        <div className="border-t border-gray-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="flex space-x-6 text-sm text-gray-400">
              <a href="#" className="hover:text-white transition-colors">이용약관</a>
              <a href="#" className="hover:text-white transition-colors">개인정보보호</a>
            </div>
            
            <div className="text-sm text-gray-400">
              © 2024 주식회사 튜링스. All rights reserved.
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
